document.addEventListener("DOMContentLoaded", function () {

  // ===============================
  // Utility: Wait for Element
  // ===============================
  function waitForElement(selector, callback) {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else {
      const observer = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) {
          callback(el);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // ===============================
  // Announcement Slider
  // ===============================
  if (typeof Swiper !== "undefined") {
    new Swiper(".header-topbar .announcement-swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      speed: 1200,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".announce-arrow.announce-button-next",
        prevEl: ".announce-arrow.announce-button-prev",
      },
    });
  }

  // ===============================
  // Menu dropdown on hover
  // ===============================
  const menuContainer = document.querySelector(".header__inline-menu");
  if (menuContainer) {
    const items = menuContainer.querySelectorAll("details");
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
      });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  }

  // ===============================
  // Product Tabs
  // ===============================
  waitForElement(".prod__tab-block .tab-nav", () => {
    const tabs = document.querySelectorAll(".prod__tab-block .tab-nav .tab");
    const panes = document.querySelectorAll(".prod__tab-block .tabs-content .tab-pane");

    // Hide all non-active panes on load
    panes.forEach(pane => {
      pane.style.display = pane.classList.contains("active") ? "block" : "none";
    });

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("active"));
        panes.forEach(p => {
          p.classList.remove("active");
          p.style.display = "none";
        });

        tab.classList.add("active");
        const target = document.getElementById(tab.dataset.tab);
        if (target) {
          target.classList.add("active");
          target.style.display = "block";
        }
      });
    });
  });

  // ===============================
  // Header Cart Data Update
  // ===============================
  function formatMoney(cents) {
    const currency = Shopify.currency?.active || "USD";
    return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(cents / 100);
  }

  function detectCartType() {
    const attr =
      document.body?.getAttribute("data-cart-type") ||
      document.documentElement?.getAttribute("data-cart-type");
    if (attr) return attr;

    if (document.querySelector("cart-drawer")) return "drawer";
    if (document.querySelector("cart-notification")) return "popup";
    return "page";
  }

  const bubble = document.querySelector("#cart-icon-bubble");
  const customCart = document.querySelector("#custom-cart");

  if (bubble) {
    const observer = new MutationObserver(() => {
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => {
          const countEl = document.querySelector("#custom-cart-count");
          const totalEl = document.querySelector("#custom-cart-total");
          if (countEl) countEl.textContent = cart.item_count;
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
        });
    });
    observer.observe(bubble, { childList: true, subtree: true });
  }

  if (customCart) {
    customCart.addEventListener("click", e => {
      const type = detectCartType();
      if (type === "drawer") {
        e.preventDefault();
        if (bubble) bubble.click();
      }
    });
  }

  // ===============================
  // Project Counter
  // ===============================
  const counters = document.querySelectorAll(".count-number");
  const speed = 100;
  counters.forEach(counter => {
    const animate = () => {
      const value = +counter.getAttribute("data-count");
      const data = +counter.innerText;
      const increment = Math.ceil(value / speed);
      if (data < value) {
        counter.innerText = data + increment;
        setTimeout(animate, 20);
      } else {
        counter.innerText = value + "+";
      }
    };
    animate();
  });

  // ===============================
  // Facet Filters (close all except first)
  // ===============================
  const filters = document.querySelectorAll(".facets__disclosure-vertical");
  filters.forEach((filter, index) => {
    if (index !== 0) filter.removeAttribute("open");
  });
});
